import { useEffect } from "react";
import LoginContainer from "./LoginContainer";
import { ACCESS_TOKEN } from "../../../constants/PreferenceKeys";
import ROUTES from "../../../constants/Routes";
import { useLocation } from "react-router-dom";

const RedirectLoginContainer = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const accessToken = query.get('accessToken');
    useEffect(() => {
        if (accessToken) {
            localStorage.setItem(ACCESS_TOKEN, accessToken);
            window.location.href = ROUTES.DASHBOARD_V2;
        }
    }, [accessToken]);
    return (
        <LoginContainer
        isManager={true}
        />
    )
}

export { RedirectLoginContainer };